import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer id="kontakt" className="w-full py-12 px-6 md:px-12 bg-gray-100" data-id="element-132">
      <div className="max-w-6xl mx-auto pt-8" data-id="element-133">
        <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-134">
          <div className="mb-4 md:mb-0" data-id="element-135">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/sBeLHqEvA69hG4RGUSQpxM/Logo-Schifferer_Sturny-final2.png" alt="Praxis für Beratung und Psychotherapie Logo" className="h-12" data-id="element-136" />
          </div>
          <div className="flex flex-col md:flex-row items-center text-gray-500 text-sm" data-id="element-137">
            <div className="flex space-x-4 mb-2 md:mb-0 md:mr-4" data-id="element-138">
              <Link to="/datenschutz" className="hover:text-[#c2cde0] transition-colors" data-id="element-139">
                Datenschutz
              </Link>
              <Link to="/impressum" className="hover:text-[#c2cde0] transition-colors" data-id="element-140">
                Impressum
              </Link>
            </div>
            <div data-id="element-141">
              © {new Date().getFullYear()} Praxis für Beratung und
              Psychotherapie. Alle Rechte vorbehalten.
            </div>
          </div>
        </div>
      </div>
    </footer>;
}